import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../../helpers/request';
import { shutdownAlisaTemplatesQuery } from '../../../../shared/api/queries';
import {
  shutdownEmitter,
  shutdownEvtNames,
} from '../../../../shared/constants';

const { key: templatesQueryKey } = shutdownAlisaTemplatesQuery;

const addTemplate = async ({ data }) => {
  const res = await request.post(
    `/Alert/alisa_templates`,
    data,
    'Не удалось сохранить шаблон',
    'Error'
  );

  return res;
};

export const useAddResponseTemplate = (options = {}) => {
  const queryClient = useQueryClient();

  const addMutation = useMutation(addTemplate, {
    ...options,
    onSuccess: async (res, { data }) => {
      if (res !== 'Error') {
        await queryClient.invalidateQueries(templatesQueryKey);
        shutdownEmitter.emit(
          shutdownEvtNames.autoResponseTemplateAddOrEdit,
          res
            ? {
                id: res.id,
                text: res.text,
              }
            : {
                text: data.value,
              }
        );
      }
    },
  });

  return {
    add: addMutation.mutateAsync,
    loading: addMutation.isLoading,
  };
};
